import { Unauthorized } from "@app/shared/ErrorPages";
import { JSX, useContext } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { TerminationsWizard } from "@app/terminations/import";
import ViewMyTerminations from "@app/terminations/ViewMyTerminations";
import Roles from "@app/user/roles";
import { UserContext } from "@app/user/UserContext";

const TerminationsRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  if (!userContext.roles.includes(Roles.VOLUME_TERMINATOR)) {
    return <Unauthorized />;
  }

  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={ViewMyTerminations} />
      <Redirect from={props.match.path} to={`${props.match.path}/view`} exact={true} />

      <Route path={`${props.match.path}/:terminationType`} render={(props: RouteComponentProps) => (
        <TerminationsWizard {...props} />
      ) } />
    </Switch>
  );
};

export default TerminationsRouter;
